import { SET_MASTER_SETTINGS_WS, SET_MASTER_SETTINGS } from './chunk-ZDDKJUP6.mjs';
import { __export } from './chunk-T36PI2YV.mjs';

// src/state/settings/master/actions.ts
var actions_exports = {};
__export(actions_exports, {
  setMasterSettings: () => setMasterSettings
});
var setMasterSettings = (payload, isWebSocket = false) => ({
  type: isWebSocket ? SET_MASTER_SETTINGS_WS : SET_MASTER_SETTINGS,
  payload
});

export { actions_exports, setMasterSettings };
